import type { ReactElement } from "react"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import { backgrounds } from "@onestore/hel/dist/components/organisms/SectionOrg/SectionOrg.settings"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import ConditionalWrapper from "@onestore/hel/dist/helpers/ConditionalWrapper"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { Components } from "react-markdown"
import UdsThemeProvider from "~/components/UdsThemeProvider"
import isEmpty from "~/lib/isEmpty"
import type { Paragraph as ParagraphType } from "~/types/squidex"
import MarkdownCaption from "../Markdown/Caption"
import MarkdownText from "../Markdown/Text"
import MarkdownTitle from "../Markdown/Title"

type Props = ParagraphType & {
  markdownOverrides?: Components
}

function Paragraph({
  caption,
  title,
  content,
  backgroundColor,
  markdownOverrides,
}: Props): ReactElement<Props> {
  return (
    <UdsThemeProvider>
      <ConditionalWrapper
        condition={!isEmpty(backgroundColor)}
        wrapper={(children) => (
          <SurfaceOrg
            color={backgroundColor ? backgrounds[backgroundColor] : undefined}
            spacingSpace={3}
          >
            {children}
          </SurfaceOrg>
        )}
      >
        {!isEmpty(caption) ? (
          <MarkdownCaption>{caption}</MarkdownCaption>
        ) : null}

        {!isEmpty(title) ? (
          <PushOrg bottomSpace={1}>
            <MarkdownTitle
              components={
                markdownOverrides ||
                getBaseMarkdownOverrides({
                  typography: "big3",
                  pushSpace: 1,
                })
              }
            >
              {title}
            </MarkdownTitle>
          </PushOrg>
        ) : null}

        <MarkdownText components={markdownOverrides}>{content}</MarkdownText>
      </ConditionalWrapper>
    </UdsThemeProvider>
  )
}

export default Paragraph
